import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-connection-wrapper center"
}
const _hoisted_2 = { class: "no-connection purple-purple-color center fw-b p-1 fs-14" }
const _hoisted_3 = { style: {"padding-right":"10px"} }
const _hoisted_4 = { class: "ion-text-center" }

import { IonApp, IonIcon, IonPage, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/vue';
import { computed, onMounted, ref } from 'vue';
import { App } from "@capacitor/app";
import { pingRequest } from "@/api-connectors/basicRequests";
import { set } from 'idb-keyval';
import { route } from "@/router";

import { useUserStore } from "@/stores/user";
import { useLocationStore } from "@/stores/locations";
import { useSupplierStore } from "@/stores/suppliers";
import { useMessagingStore } from "@/stores/messaging";
import { usePersistentStore } from "@/stores/persistent";
import { useListStore } from "@/stores/lists";
import { useNotificationStore } from "@/stores/notification";

import { useApi } from "@/composables/useApi";

import { setPreference } from "@/functions/preferences";
import { isApp } from "@/functions/enviroment";

import {
    chatboxOutline,
    homeOutline,
    listOutline,
    pricetagsOutline,
    settingsOutline,
    wifiOutline
} from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userStore = useUserStore()
const locationStore = useLocationStore()
const supplierStore = useSupplierStore()
const messagingStore = useMessagingStore()
const persistentStore = usePersistentStore()
const notificationStore = useNotificationStore()
const listStore = useListStore()
const { testCount } = useApi()

const languageWatcher = ref<number>(0)

const locationId = computed<string>(() => String(route.value.params.locationId ?? ''))

// UserStore and Persistent in Preference for better consistency
userStore.$subscribe((mutation, state) => {
    setPreference('userStore', JSON.stringify(state))
})

persistentStore.$subscribe((mutation, state) => {
    setPreference('persistentStore', JSON.stringify(state))
})

// other stores in indexedDB for faster access
locationStore.$subscribe((mutation, state) => {
    set('locationStore', JSON.stringify(state))
    // setPreference('locationStore', JSON.stringify(state))
})
supplierStore.$subscribe((mutation, state) => {
    set('supplierStore', JSON.stringify(state))
})

messagingStore.$subscribe((mutation, state) => {
    set('messagingStore', JSON.stringify(state))
})

listStore.$subscribe((mutation, state) => {
    set('listStore', JSON.stringify(state))
})

notificationStore.$subscribe((mutation, state) => {
    set('notificationStore', JSON.stringify(state))
})

let pingRunning = false
let appInBackground = false

//? catches end-characters (CR, ...) of the scanner, that cause the app to trigger unwanted events
const catchScanEndCharacter = (input: KeyboardEvent) => {
    if (!isApp() || process.env.VUE_APP_DEVELOPMENT_ENV === 'APP') return
    if (isNaN(parseInt(input.key)) && input.target?.localName !== "input" && input.target?.localName !== "textarea") {
        input.preventDefault()
        input.stopPropagation()
        return
    }
    // scannerStore.scannerResult += input.key
}

const pingServer = async (): Promise<void> => {
    if (pingRunning) return
    pingRunning = true
    let ping = true
    ping = await pingRequest()

    persistentStore.noConnection = !ping;

    pingRunning = false
}

App.addListener('appStateChange', state => {
    if (!state.isActive) return appInBackground = true
    appInBackground = false
})

const setup = async (): Promise<void> => {
    if (!persistentStore.offlineMode) await pingServer()

    setInterval(() => {
        if (!persistentStore.offlineMode && !appInBackground) pingServer()
    }, 5000)
}

onMounted(setup)

window.addEventListener('change-language', () => {
    languageWatcher.value++
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), {
    onKeydown: _cache[0] || (_cache[0] = ($event: any) => (catchScanEndCharacter($event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonPage), null, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_unref(IonTabs), {
            class: "custom-tabs-background",
            key: languageWatcher.value
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_unref(IonRouterOutlet), {
                key: _unref(testCount),
                animated: _unref(isApp)()
              }, null, 8, ["animated"])),
              (_ctx.$route.path.includes(locationId.value) && !_ctx.$route.meta?.noTabs && _unref(isApp)())
                ? (_openBlock(), _createBlock(_unref(IonTabBar), {
                    key: 0,
                    slot: "bottom",
                    class: "button-grey-2 custom-tab-bar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonTabButton), {
                        tab: "home",
                        href: (locationId.value) ? `/dashboard/${locationId.value}/home` : '/home'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(homeOutline),
                            size: "small"
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('object.home')), 1)
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      _createVNode(_unref(IonTabButton), {
                        tab: "message",
                        href: (locationId.value) ? `/dashboard/${locationId.value}/message-overview` : '/home'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(chatboxOutline),
                            size: "small"
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('object.message', 2)), 1)
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      _createVNode(_unref(IonTabButton), {
                        tab: "list",
                        href: (locationId.value) ? `/dashboard/${locationId.value}/list-overview` : '/home'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(listOutline),
                            size: "small"
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('object.list', 2)), 1)
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      _createVNode(_unref(IonTabButton), {
                        tab: "promotion",
                        href: (locationId.value) ? `/dashboard/${locationId.value}/promotion` : '/home'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(pricetagsOutline),
                            size: "small",
                            class: "flipped"
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('object.promotion', 2)), 1)
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      _createVNode(_unref(IonTabButton), {
                        tab: "setting",
                        href: (locationId.value) ? `/dashboard/${locationId.value}/settings` : '/home'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: _unref(settingsOutline),
                            size: "small"
                          }, null, 8, ["icon"]),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('object.setting')), 1)
                        ]),
                        _: 1
                      }, 8, ["href"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        ]),
        _: 1
      }),
      (_unref(persistentStore).noConnection)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(IonIcon), {
                  src: _unref(wifiOutline),
                  size: "large"
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.noConnection1')) + ".", 1),
                _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.$t('messages.noConnection2')) + ". ", 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})